<template>
<div class="addrDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' title="编辑提货点" :visible.sync="dialogVisible">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm form">
            <el-form-item label="提货点名称" prop="name" class="content">
                <el-input v-model.trim="item.name" placeholder="请输入提货点名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="提货点位置" class="content" prop="provicename">
                <el-cascader :options="citysList" @change="selectedCity" ref="myCascader"  v-model="currentCity"></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址" prop="address" class="content">
                <el-input v-model.trim="item.address" placeholder="请输入详细地址" clearable></el-input>
            </el-form-item>
            <div class="link">
                <el-form-item label="提货点联系人" prop="linkman" class="content">
                    <el-input v-model.trim="item.linkman" placeholder="请输入提货点联系人" clearable></el-input>
                </el-form-item>
                <el-form-item label="提货点电话" prop="linktel" class="content">
                    <el-input v-model.trim="item.linktel" placeholder="请输入提货点电话" maxlength="20" clearable></el-input>
                </el-form-item>
            </div>
            <div class="switch" v-if="item.ppinnerid &&item.pptype==2">
                <el-form-item label="所属团长" class="content">
                    <div class="roleinfo">
                        <img class="img" :src="item.objrolelogo" alt="">
                        <span>{{item.objrolename}}</span>
                    </div>
                </el-form-item>
            </div>
            <div class="link"  v-if="item.ppinnerid &&item.pptype==2">
                <el-form-item label="团长佣金（%）" class="content" prop="objrate">
                    <el-input v-model.trim="item.objrate" placeholder="请输入团长佣金" clearable></el-input>
                </el-form-item>
                <el-form-item label="推荐佣金（%）" class="content" prop="objrecommend">
                    <el-input v-model.trim="item.objrecommend" placeholder="请输入推荐佣金" clearable></el-input>
                </el-form-item>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
    </span>
    </el-dialog>
    <invateLinkDialog ref="invateLinkDialog"></invateLinkDialog>
</div>
</template>

<script>
import {getPickupPointInfoByHost, uploadPickupPointByHostRole} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import InvateLinkDialog from 'views/brandBusiness/leaderMgt/myLeader/components/invateLinkDialog.vue'
import citys from 'common/js/citys.json'
export default {
    name: 'addrDialog',
    data() {
        let validateHeaderrate = (rule, value, callback) => {
            if (parseFloat(value) > 100) {
                callback(new Error('团长佣金比例不能超过100%'))
            } else {
                callback()
            }
        }
        let validateRecommendrate = (rule, value, callback) => {
            if (parseFloat(value) > 100) {
                callback(new Error('推荐团长佣金团长佣金比例不能超过100%'))
            } else {
                callback()
            }
        }
        return {
            citysList: citys,
            currentCity: [],
            item: {
                proviceid: '',
                cityid: '',
                countid: '',
                address: '',
                cityname: '',
                countname: '',
                linkman: '',
                linktel: '',
                name: '',
                provicename: '',
                mapaddress: '',
                ppinnerid: '',
                objrate: '',
                objrecommend: '',
                objroleinnerid: '',
                objroletype: 2,
            },
            proviceList: [],
            cityList: [],
            countList: [],
            dialogVisible: false,
            rules: {
                name: [
                    {required: true, message: '请输入提货点名称', trigger: 'blur'}
                ],
                address: [
                    {required: true, message: '请输入详细地址', trigger: 'blur'}
                ],
                provicename: [
                    {required: true, message: '请选择提货点位置', trigger: 'blur'}
                ],
                linkman: [
                    {required: true, message: '请输入提货点联系人', trigger: 'blur'}
                ],
                linktel: [
                    {required: true, message: '请输入提货点电话', trigger: 'blur'},
                    // {pattern: /^1[3|4|5|7|8][0-9]{9}$/, message: '请输入正确的手机号码', trigger: 'blur'},
                    {pattern: /^[0-9]{6,20}$/, message: '请输入正确的手机号码', trigger: 'blur'},
                ],
                objrate: [
                    {required: true, message: '请输入提团长佣金', trigger: 'blur'},
                    {pattern: /^([1-9][0-9]*)+(\.[0-9]{1,2})?$/, message: '请输入正确的团长佣金(2位小数)', trigger: 'blur'},
                    {validator: validateHeaderrate, trigger: 'blur'},
                ],
                objrecommend: [
                    {required: true, message: '请输入推荐团长佣金', trigger: 'blur'},
                    {pattern: /^([1-9][0-9]*)+(\.[0-9]{1,2})?$/, message: '请输入正确的推荐团长佣金(2位小数)', trigger: 'blur'},
                    {validator: validateRecommendrate, trigger: 'blur'},
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        selectedCity(city) {
            this.item.proviceid = city[0]
            this.item.cityid = city[1]
            this.item.countid = city[2]
            let nameList = this.$refs.myCascader.getCheckedNodes()[0].pathLabels
            this.item.provicename = nameList[0]
            this.item.cityname = nameList[1]
            this.item.countname = nameList[2]
        },
        openDialog(obj) {
            this.dialogVisible = true
            if (obj) {
                this.item.ppinnerid = obj.ppinnerid
                this._getView()
            } else {
                this.item = {
                    proviceid: '',
                    cityid: '',
                    countid: '',
                    address: '',
                    cityname: '',
                    countname: '',
                    linkman: '',
                    linktel: '',
                    name: '',
                    provicename: '',
                    mapaddress: '',
                    ppinnerid: '',
                    objrate: '',
                    objrecommend: '',
                    objroleinnerid: '',
                    objroletype: 2,
                }
            }
        },
        cancel() {
            this.currentCity = []
            this.dialogVisible = false
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认保存提货点', '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._save()
                    })
                }
            })
        },
        _save() {
            this.setLoading(true)
            let obj = this._.cloneDeep(this.item)
            if (this.item.ppinnerid && this.item.pptype == 1) {
                delete obj.objroleinnerid
            }
            uploadPickupPointByHostRole({
                data: Object.assign({}, obj, this.role),
                success: data => {
                    this.$message.success('编辑成功')
                    if (this.item.ppinnerid) {
                        this.setIsRefresh(1)
                    } else {
                        this.setIsRefresh(2)
                    }
                    this.$emit('getList')
                    this.setLoading(false)
                    this.cancel()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getPickupPointInfoByHost({
                data: Object.assign({}, {ppinnerid: this.item.ppinnerid}),
                success: data => {
                    this.item = data.data
                    this.currentCity = [this.item.proviceid, this.item.cityid, this.item.countid]
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams',
            'setIsRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['page', 'brandBusiness', 'user', 'params',])
    },
    components: {
        InvateLinkDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.addrDialog {
    .form{
        margin-top: 0;
    }
    .el-radio-group {
        margin-bottom: 20px;
        .el-radio + .el-radio {
            margin-top: 20px;
        }
    }
    .el-dialog__footer {
    }
    .switch{
        display: flex;
        padding-top: 20px;
        border-top: 1px solid #DCDFE6;
        .roleinfo{
            display: flex;
            align-items: center;
            .img{
                width: 30px;
                height: 30px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
    }
    .addr{
        display: flex;
        .el-select+.el-select{
            margin-left: 10px;
        }
    }
    .link{
        display: flex;
    }
}
</style>
